import { render } from "./ElectricTableComponent.vue?vue&type=template&id=f2f394bc"
import script from "./ElectricTableComponent.vue?vue&type=script&lang=js"
export * from "./ElectricTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__